import { useUrlParams } from '~/modules/artist-roster/hooks/useUrlParams';
import type { ArtistUrlParamsHook } from '~/modules/artist-roster/hooks/useUrlParams/types';
import {
  formatFiltersToUrlParams,
  parseFiltersFromUrlParams,
} from '~/modules/artist-roster/pages/artist-details/utils/parsers/filters';
import type { TracksFilters } from '~/modules/artist-roster/pages/artist-details/utils/types';

/**
 * Hook to manage URL parameters for the tracks page.
 * {@link ArtistUrlParamsHook}
 */
export function usePreReleasesUrlParams(): ArtistUrlParamsHook<TracksFilters> {
  return useUrlParams<TracksFilters>(
    formatFiltersToUrlParams,
    parseFiltersFromUrlParams,
  );
}
